import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";

function SocialworkerSuggestion() {
  const ID = Cookies.get("log_id");
  const [candidates, setCandidates] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3;

  // Fetch data from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${url.path}/socialworker_suggestion/`, {
          params: { id: ID },
        });
        if (res.data.status) {
          setCandidates(res.data.unemployed);
        }
      } catch (error) {
        Toast.fire({
          icon: "error",
          title: error.message,
        });
      }
    };
    fetchData();
  }, [ID]);

  // Filtered data based on search term
  const filteredData = candidates.filter((item) =>
    item.Candidate_Name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Paginated data based on filtered list
  const offset = currentPage * itemsPerPage;
  const currentItems = filteredData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0); // Reset to the first page when search term changes
  };

  const handleOpenModal = (candidate) => {
    setSelectedCandidate(candidate);
  };

  const handleCloseModal = () => {
    setSelectedCandidate(null);
  };

  const handleSubmit = () => {
    const formdata = new FormData();
    formdata.append("id", ID);
    formdata.append("unemployed", selectedCandidate.id);
    formdata.append("status", "Submitted");

    axios
      .post(`${url.path}/socialworker_submit/`, formdata)
      .then((res) => {
        if (res.data.status) {
          Toast.fire({
            icon: "success",
            title: "Socialworker Submitted",
          });
          // Re-fetch the candidates list to reflect any updates
          setCandidates((prevState) =>
            prevState.filter((item) => item.id !== selectedCandidate.id) // Remove submitted candidate from the list
          );
        }
      })
      .catch((err) => {
        Toast.fire({
          icon: "error",
          title: err.message,
        });
      });

    handleCloseModal();
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });

  return (
    <>
      <Navbar />
      <center>
        <h3 style={{ fontSize: "20px", position: "relative", top: "10px" }}>
          Suggestion and counselling
        </h3>
      </center>
      <div className="search-container">
        <input
          type="text"
          placeholder="Search..."
          onChange={handleSearchChange} // Update search term on input change
          value={searchTerm}
          className="search-input"
          id="search"
        />
      </div>
      <div className="table-container">
        <table className="responsive-table" id="unemptable">
          <thead>
            <tr>
              <th>Sl.No</th>
              <th>Name</th>
              <th>Email</th>
              <th>Contact</th>
              <th>Parent Details</th>
              <th>Type of Problem</th>
              <th>Problem Statement</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length === 0 ? (
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  No candidates found
                </td>
              </tr>
            ) : (
              currentItems.map((i, index) => (
                <tr key={i.id}>
                  <td>{offset + index + 1}</td>
                  <td>{i.Candidate_Name}</td>
                  <td>{i.Email}</td>
                  <td>{i.Contact}</td>
                  <td>{i.Parent_Details}</td>
                  <td>{i.Typeof_problem}</td>
                  <td>{i.Problem_statement}</td>
                  <td>
                    <button
                      type="button"
                      style={{
                        width: "80px",
                        backgroundColor: "green",
                        color: "white",
                        borderRadius: "5px",
                      }}
                      onClick={() => handleOpenModal(i)}
                    >
                      Submit
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        {filteredData.length > itemsPerPage && (
          <ReactPaginate
            previousLabel={"← Previous"}
            nextLabel={"Next →"}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
          />
        )}
      </div>

      {selectedCandidate && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleCloseModal}>
              ×
            </button>
            <h2>Verify Candidate</h2>
            <p>Are you sure to submit {selectedCandidate.Candidate_Name}?</p>
            <form>
              <center>
                <button
                  type="button"
                  onClick={handleSubmit}
                  style={{
                    width: "100px",
                    backgroundColor: "gainsboro",
                    borderRadius: "5px",
                  }}
                >
                  Submit
                </button>
              </center>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default SocialworkerSuggestion;